Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Card1487855116",
  {"card":"Card1487855116--card","controls":"Card1487855116--controls","root":"Card1487855116--root"},
  ".Card1487855116--card{position:relative;background:#fff;border-radius:8px}.Card1487855116--card[data-card1487855116-stretchvertically]{height:100%;flex-grow:1}.Card1487855116--card[data-card1487855116-hideoverflow]{overflow:hidden}.Card1487855116--controls{position:absolute;top:0;right:0;padding:6px}.rtl .Card1487855116--controls,[dir=rtl] .Card1487855116--controls{left:0;right:auto}",
  2,
  "Card1487855116"
);
__webpack_require__.stylable.$.register(exports.default)
